import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { SubjectService } from '../../services/subject.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ValidationService } from '../../services/validation.service';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { strict } from 'node:assert';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';
@Component({
  selector: 'app-subject-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, FilterByKeyAndValuePipe, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SelectInputComponent, SearchInputComponent, BulkUploadComponent, NgIf, DropdownUploadButtonComponent],
  templateUrl: './subject-list-page.component.html',
  styleUrl: './subject-list-page.component.css'
})
export class SubjectListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Subject';
  form: FormGroup;
  params: any = {};
  selected_subject_ids: any = {}
  items: any[] = [];
  isSubmitting = false;
  show_menu = false;

  city_cols: any = [
    { headerName: 'Sr.No', field: 'SrNo' },
    { field: 'University.name', headerName: 'School', filter: true, flex: 1, },
    // { field: 'College.name', headerName: 'College Name', filter: true, flex: 1, },
    { field: 'Level.name', headerName: 'Level', filter: true, flex: 1, },
    { field: 'Program.name', headerName: 'Program', filter: true, flex: 1, },
    { field: 'name', headerName: 'Subject Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'Subject Code', filter: true, flex: 1, },
    { headerName: 'Contact Details', filter: true, flex: 2, valueGetter: (p: any) => [p.data?.contact, p.data?.email].filter(Boolean).join(`, `) },
    { field: 'is_active', headerName: 'Status', filter: true, flex: 1, valueGetter: (params: any) => params.data?.is_active, cellRenderer: (params: any) => { return params.value ? 'Enable' : 'Disable'; } },
    { headerName: "Actions", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 210, minWidth: 210, maxWidth: 210 }
  ];
  bulk_columns = [
    { column_name: 'School', type: 'link', linked_list: 'university_list', returning_key: 'id', return_as: 'university_id', sample_value: 'ABC School' },
    // { column_name: 'College Name', type: 'link', linked_list: 'college_list', parent_column: 'university_id', parent_key: 'university_id', returning_key: 'id', return_as: 'college_id', sample_value: 'ICL', },
    { column_name: 'Level Name', type: 'link', linked_list: 'level_list', returning_key: 'id', return_as: 'level_id', sample_value: 'One' },
    { column_name: 'Program', type: 'link', linked_list: 'program_list', returning_key: 'id', return_as: 'program_id', sample_value: 'XYZ' },
    { column_name: 'Stream', type: 'link', linked_list: 'stream_list', returning_key: 'id', return_as: 'stream_id', sample_value: 'XYZ' },
    { column_name: 'Subject Name', type: 'text', return_as: 'name', sample_value: 'Java', is_unique: true, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex: this.vs.name_pattern, regex_error: `Please enter a valid ${this.page_name} Name` },
    { column_name: 'Subject Code', type: 'text', return_as: 'code', sample_value: '1101', is_unique: true, min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, regex: this.vs.code_pattern },
    { column_name: 'credits', type: 'text', return_as: 'credits', sample_value: '10', max_length: this.vs.max_length_credits, strict_validation: 'number', skip_validation: true },
    { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: '1234567890', skip_validation: true },
    { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'xyz@gmail.com', skip_validation: true },
  ];
  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.masters_course_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.masters_course_view })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.masters_course_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete_modal_open.bind(this), permissions: this.gs.user_role_data?.masters_course_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ss: SubjectService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      university_id: ['', [Validators.required]],
      // college_id: ['', [Validators.required]],
      level_id: ['', [Validators.required]],
      program_id: ['', [Validators.required]],
      stream_id: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.pattern(this.vs.name_pattern), Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      email: ['', [Validators.pattern(this.vs.email_pattern), Validators.maxLength(this.vs.max_length_email)]],
      credits: ['', [Validators.pattern('^(?:[0-9]|1[0-9]|20)$')]],
      contact: ['', [Validators.minLength(this.vs.min_length_contact), Validators.maxLength(this.vs.max_length_contact), Validators.pattern(this.vs.contact_pattern)]],
      is_active: [true]
    });
  }
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['university', 'program', 'stream', 'level', 'college']);
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      await this.get_list(this.params)
    })
  }
  async get_list(filter?: any) {
    const res = await this.ss.get_list(filter);
    const page = filter?.page || 1;
    const pagesize = filter?.page_size || 10;
    const startindex = (page - 1) * pagesize;

    res.data = res.data.map((item: any, index: number) => ({
      ...item,
      SrNo: startindex + index + 1
    }));

    this.items = res;
  }
  async delete_modal_open(item: any, index: any) {
    this.selected_subject_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_subject_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  open_view_modal(item: any) {
    console.log(item);
    this.selected_subject_ids = item || {};
    this.view_modal?.open();
  }
  async delete_subject() {
    try {
      let res = await this.ss.delete(this.selected_subject_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_subject_ids = {};
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('subject');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.ss.update(this.selected_subject_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('subject');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      await this.ss.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    this.ds.invalidate_dropdown_cache('subject');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    this.selected_subject_ids = item || {};
    if (this.selected_subject_ids && this.selected_subject_ids.id) {
      let response = await this.ss.get(item.id);
      this.selected_subject_ids = this.gs.addHierarchyIds({ ...response.data });
      this.form.patchValue({ ...this.selected_subject_ids, });
    } else {
      this.selected_subject_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.form.value;
      form_value.is_active = true;
      if (this.selected_subject_ids && this.selected_subject_ids.id) {
        let update_response = await this.ss.update(this.selected_subject_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.ss.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.ds.invalidate_dropdown_cache('subject');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }
  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.ss, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }

}
